export default class ListingDataInfo {
  constructor(data = {}) {
    this.depositAmount = data.depositAmount;
    this.leaseMonths = data.leaseMonths;
    this.rentAmount = data.rentAmount;
    this.isAvailableForRent = data.isAvailableForRent;
  }
}
